import { __assign } from "tslib";
import { getLegacyBaseDriverFromWrapper } from '../../common/base-driver';
import { renderAndMountComponent } from '@wix/answers-lib';
import * as React from 'react';
import { GroupAvatar } from './group-avatar';
export var createGroupAvatarDriver = function (wrapper) {
    var baseDriver = getLegacyBaseDriverFromWrapper(wrapper, '.group-avatar', GroupAvatar.name);
    return {
        getInitials: function () { return baseDriver.find('.inner').getText(); },
        isProfileImgVisible: function () { return baseDriver.isChildVisible('img'); },
        isInitialsVisible: function () { return baseDriver.isChildVisible('initials'); },
        hasAutoRoutingIcon: function () { return baseDriver.isChildVisible('.lightning-icon'); },
    };
};
export var createGroupAvatar = function (props, children) {
    var element = renderAndMountComponent(React.createElement(GroupAvatar, __assign({}, props), children));
    return createGroupAvatarDriver(element);
};
//# sourceMappingURL=group-avatar.driver.js.map